import 'core-js/features/number/is-integer';
import '@hookstate/devtools';
import '@mineko/js-browser-core';
import React from 'react';
import ReactDOM from 'react-dom';

import { ConfigProvider, SentryErrorBoundary } from 'react-commons';
import { FallbackContainer } from 'react-commons/components/ErrorBoundary/ErrorFallback';
import App from './App';
import './state/persistence/bootstrapGlobalState';
import './i18n';

console.log('Version:', window['VERSION']);
const configs = [
  { name: 'APP', url: `${process.env.REACT_APP_ORDER_URL}/config.json` },
  {
    name: 'ENV',
    url: `${process.env.REACT_APP_ORDER_URL}/config/${location.hostname}.json?version=${window['VERSION']}`,
  },
];

ReactDOM.render(
  <React.StrictMode>
    <SentryErrorBoundary fallback={FallbackContainer}>
      <ConfigProvider items={configs}>
        <App />
      </ConfigProvider>
    </SentryErrorBoundary>
  </React.StrictMode>,
  document.getElementById('app'),
);
